import { RootState } from '@/store/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectSkillIsInitializing = createSelector(
  [(state: RootState) => state.skillsState.skillInitLoading, (_state: RootState, props: { skill: string }) => props.skill],
  (loadingSkill, skill): boolean => {
    return loadingSkill === skill
  }
)

export const selectSkillIsErrored = createSelector(
  [(state: RootState) => state.skillsState.skillInitError, (_state: RootState, props: { skill: string }) => props.skill],
  (errorSkill, skill): boolean => {
    return errorSkill === skill
  }
)

export const selectPendingSkillForConversation = (state: RootState, props: { conversationId: string }) =>
  state.skillsState.activeSkillForConversation[props.conversationId] ?? null
